import { z } from 'zod'

export const workTagSchema = z.string().trim().toLowerCase().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).max(32)
export const workTagsSchema = z.array(workTagSchema).max(8).transform(tags => [...new Set(tags)].sort())
export function workTags(value: unknown): Array<string> {
  try {
    const parsed = workTagsSchema.safeParse(typeof value === 'string' ? JSON.parse(value) : value)
    return parsed.success ? parsed.data : []
  } catch { return [] }
}
